import { FC, ReactNode } from "react";
import { List as MdList } from "@rmwc/list";
import "@rmwc/list/styles";
import Direction from "../../../commons/Direction";

export type ListProps = {
  children: ReactNode;
  twoLine?: undefined | boolean;
  dir?: Direction;
  className?: string;
  onChange?: Function;
  value?: string;
};

const List: FC<ListProps> = ({ children, twoLine = true, className, dir = Direction.RTL }) => {
  return (
    <MdList twoLine={twoLine} dir={dir}>
      {children}
    </MdList>
  );
};

export default List;
